import { absoluteUrl, SITE_NAME, SITE_ORIGIN } from './site'
import type { PageSeo } from './pages'
import { portalLinks } from '../portal-links'

export function organizationJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE_NAME,
    url: SITE_ORIGIN,
    logo: absoluteUrl('/pwa/client/icon-512.png'),
    description:
      'Perfect Predict offers structured prediction trading on Gold and Silver with predefined strategy parameters and MetaTrader 5 execution.',
  }
}

export function websiteJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    url: SITE_ORIGIN,
    publisher: { '@type': 'Organization', name: SITE_NAME, url: SITE_ORIGIN },
  }
}

export function webPageJsonLd(page: PageSeo) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: page.title,
    description: page.description,
    url: absoluteUrl(page.path === '/' ? '/' : page.path),
    isPartOf: { '@type': 'WebSite', name: SITE_NAME, url: SITE_ORIGIN },
    inLanguage: 'en',
  }
}

export function breadcrumbJsonLd(page: PageSeo) {
  const crumbs = page.breadcrumbs || [{ name: page.h1, path: page.path }]
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: crumbs.map((c, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: c.name,
      item: absoluteUrl(c.path === '/' ? '/' : c.path),
    })),
  }
}

/** Only call when the exact FAQ content is visible on the same page. */
export function faqPageJsonLd(items: readonly { q: string; a: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((item) => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: { '@type': 'Answer', text: item.a },
    })),
  }
}

export function defaultPageGraph(page: PageSeo, extras: unknown[] = []) {
  const graph = [organizationJsonLd(), websiteJsonLd(), webPageJsonLd(page), breadcrumbJsonLd(page), ...extras]
  return graph
}

export { portalLinks }
